import { Transition } from '@oneToOne/shared/twind'
import { css } from 'twind/css'

export const expandedHeaderImageContainer = css({
  maxHeight: '300px',
  background: '#e3e3e3',
})

export const expandedHeaderTitle = css({
  color: 'var(--blk1)',
})

export const expandedHeaderDescription = css({
  color: 'black',
})

export const permissionBubble = css`
  ${Transition}
  background-color: var(--white);
  color: var(--blk2);
  width: fit-content;
  white-space: nowrap;
  z-index: 1;
  top: -48px;

  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-style: solid;
    border-width: 10px 8px 0 8px;
    border-color: var(--white) transparent transparent transparent;
  }
`

export const deviceButtonContainer = css`
  width: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`
